import React from 'react'
import { Grid, Typography } from '@mui/material'
import styles from './index.module.css'

const Total = ({totalPrice,currencyCode, Introduction}) => {
  return (
    <Grid container className={styles.totalContainer}>
        <Grid item className={styles.introduction}>
            {/*<Typography variant="h4">{currencyCode} - {totalPrice} kits</Typography>*/}
            {Introduction}
        </Grid>
    </Grid>
  )
}

export default Total